import {
  RemoveFormContentProps,
  RemoveTypeOption,
  RemoveTypes,
} from './interfaces';
import RemoveEPS from './RemoveEPS';
import RemoveCustomer from './RemoveCustomer';
//import RemoveAll from './RemoveAll';

export const removeTypeOptions: RemoveTypeOption[] = [
  {
    label: 'Remover por EPS ',
    value: 'EPS',
  },
  {
    label: 'Remover por cliente',
    value: 'Client',
  },
];

export const ContentComponent: {
  [key in RemoveTypes]: ({
    handleClose,
  }: RemoveFormContentProps) => JSX.Element;
} = {
  EPS: RemoveEPS,
  Client: RemoveCustomer,
  //All: RemoveAll,
};
